import { render, staticRenderFns } from "./ItirazinIptaliAlacakKalemiForm.vue?vue&type=template&id=4425d45a"
import script from "./ItirazinIptaliAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./ItirazinIptaliAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports